import { a as a$1 } from './chunk-IMSWER4T.js';

var a=class{_client=a$1.instance;async getProductVariants(t){return (await this._client.get(`/variants/${t}`)).data}async deleteVariant(t){await this._client.delete(`/variants/${t}`);}async createProductVariant(t,e){return (await this._client.post(`/variants/${t}`,e)).data}};

export { a };
//# sourceMappingURL=chunk-HQBAVHJA.js.map
//# sourceMappingURL=chunk-HQBAVHJA.js.map